module.exports = __webpack_public_path__ + "img/forgot-password-v2.e5652687.svg";